/**
 * Copyright (C) Radiojar S.A. - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 *
 * Created by Tasos Kolokathis on 12/3/24.
 */

import _ from "lodash";

export default ({mutations = [], state = [], clientId} = {}) => {
	const broadcastChannel = new BroadcastChannel(`shared-store-${clientId}`);
	let sharingInProgress = false;
	let stateSynced = false;

	return (store) => {
		store.subscribe((mutation) => {
			if (sharingInProgress) {
				return false;
			}

			if (mutations.includes(mutation.type)) {
				// Deep clone in order to case ProxyObjects come from store to plain Objects. Proxy Objects do not work with Broadcast Channels
				mutation.payload = _.cloneDeep(mutation.payload);
				broadcastChannel.postMessage({mutation});
			}
		});

		broadcastChannel.addEventListener("message", event => {
			const {mutation, requestState, stateSnapshot} = event.data;

			if (mutation) {
				try {
					sharingInProgress = true;
					store.commit(mutation.type, mutation.payload);
				} finally {
					sharingInProgress = false;
				}
			}
			// Another (newly opened) window asks for the current shared state.
			// Reply with a snapshot of the whitelisted state paths so that it does
			// not start empty and stays in sync with the already running windows.
			else if (requestState) {
				const snapshot = {};
				state.forEach(path => {
					snapshot[path] = _.cloneDeep(_.get(store.state, path));
				});
				broadcastChannel.postMessage({stateSnapshot: snapshot});
			}
			// Received the current shared state from an already running window.
			// Apply it once so that this window mirrors the existing store.
			else if (stateSnapshot && !stateSynced) {
				stateSynced = true;
				Object.entries(stateSnapshot).forEach(([path, value]) => {
					if (value !== undefined) {
						_.set(store.state, path, value);
					}
				});
			}
		});

		// When this window is created, request the current shared state from any
		// other window that might already be running (e.g. the main Live Console
		// window when the MidiUI window is opened afterwards).
		broadcastChannel.postMessage({requestState: true});
	};
};
